import DashboardNavbar from "../../../components/Navbars/DashboardNavbar";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import Grid from "@mui/material/Grid";
import Footer from "../../../components/Footer";
import usePatientDetails from "./usePatientDetails";
import DashboardLayout from "../../../components/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import React from "react";
import PersonAddIcon from '@mui/icons-material/PersonAddOutlined';
import AttachMoneyIcon from '@mui/icons-material/AttachMoneyOutlined';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import ReceiptIcon from '@mui/icons-material/Receipt';
import Sales from "./components/Sales/Sales";

const PatientDetails = () => {

    const {id, patient, isLoading, renderStatusChip} = usePatientDetails();

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={2}>
                {
                    isLoading ?
                        <MDBox mt={2} mx={2} p={10} display="flex" justifyContent="center"
                               alignItems="center">
                            <CircularProgress color="secondary" style={{overflow: 'hidden'}}/>
                        </MDBox> :
                        <>
                            <Grid container justifyContent="center">
                                <Grid item xs={12} lg={12}>
                                    <Card>
                                        <MDBox p={4}>
                                            <MDBox>
                                                <MDBox>
                                                    <MDTypography variant="h4">{patient.name} {patient.last_name} {patient.mother_last_name}</MDTypography>
                                                    <MDTypography variant="subtitle2">{patient.notes}</MDTypography>
                                                </MDBox>
                                            </MDBox>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} lg={9}>
                                                    <Sales id={id} />
                                                </Grid>
                                                <Grid item xs={12} lg={3}>
                                                    <MDBox mb={2} mt={2} sx={{padding: 2, borderStyle: 'solid', borderWidth: 1, borderColor: '#e2e2e2', borderRadius: 2}}>
                                                        <MDTypography variant="h6" sx={{marginBottom: 2}}>Información General</MDTypography>
                                                        <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                            <PersonAddIcon></PersonAddIcon>
                                                            <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{patient.doctor.name}</MDTypography>
                                                        </MDBox>
                                                        <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 1}}>
                                                            <ReceiptIcon></ReceiptIcon>
                                                            <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{patient.purchases_count} pedido(s)</MDTypography>
                                                        </MDBox>
                                                        <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 1}}>
                                                            <AttachMoneyIcon></AttachMoneyIcon>
                                                            <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>${patient.total_amount_spent.toFixed(2)}</MDTypography>
                                                        </MDBox>
                                                        <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 1}}>
                                                            <CalendarTodayIcon></CalendarTodayIcon>
                                                            <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{patient.created_at}</MDTypography>
                                                        </MDBox>
                                                    </MDBox>
                                                    {
                                                        (patient.email !== null || patient.phone !== null) &&
                                                        <MDBox mb={2} mt={2} sx={{padding: 2, borderStyle: 'solid', borderWidth: 1, borderColor: '#e2e2e2', borderRadius: 2}}>
                                                            <MDTypography variant="h6" sx={{marginBottom: 2}}>Información Personal</MDTypography>
                                                            {
                                                                patient.email !== null &&
                                                                <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                                    <EmailIcon></EmailIcon>
                                                                    <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{patient.email}</MDTypography>
                                                                </MDBox>
                                                            }
                                                            {
                                                                patient.phone !== null &&
                                                                <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 1}}>
                                                                    <PhoneIcon></PhoneIcon>
                                                                    <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{patient.phone}</MDTypography>
                                                                </MDBox>
                                                            }
                                                            {
                                                                patient.date_of_birth !== null &&
                                                                <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 1}}>
                                                                    <CalendarTodayIcon></CalendarTodayIcon>
                                                                    <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{patient.date_of_birth}</MDTypography>
                                                                </MDBox>
                                                            }
                                                        </MDBox>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    </Card>
                                </Grid>
                            </Grid>
                        </>
                }
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default PatientDetails;
